import { render, staticRenderFns } from "./addedit-vesselType.vue?vue&type=template&id=aa3a6e9c"
import script from "./addedit-vesselType.vue?vue&type=script&lang=js"
export * from "./addedit-vesselType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports